/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import { Grid } from '@mui/material'
import { State } from '@hookstate/core'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import { IActionTaken, IAuxiliaryOrgans } from '~/features/Management/interfaces'
import { useLang } from '~/hooks/useLang'

interface OrgansFiltersProps {
  readonly actionTaken: State<IActionTaken | null>
  readonly auxiliaryOrgans: State<IAuxiliaryOrgans | null>
  readonly getActionTakens: <T = Record<string, string>>(
    id?: string
  ) => Promise<readonly T[]>
  readonly getAuxiliaryOrgans: <T = Record<string, string>>(
    id?: string
  ) => Promise<readonly T[]>
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function OrgansFilters({
  actionTaken,
  auxiliaryOrgans,
  getActionTakens,
  getAuxiliaryOrgans,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: OrgansFiltersProps) {
  const { translate } = useLang()

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Auxiliary Organ')}
          onValueChange={(item) =>
            auxiliaryOrgans.set(item as unknown as IActionTaken)
          }
          valueId={auxiliaryOrgans.get()?.id as unknown as string}
          optionsFetch={getAuxiliaryOrgans}
          disabled={disableFields}
        />
      </Grid>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={actionTaken.get()?.id as unknown as string}
          label={translate('Action Taken')}
          onValueChange={(item) =>
            actionTaken.set(item as unknown as IActionTaken)
          }
          optionsFetch={getActionTakens}
          disabled={disableFields}
        />
      </Grid>

      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
